import { JEV_SKIP_REASONS, type JevSkipCounts, type JevSkipReason } from '@nadoutong/contracts';
import type { I18nKey, TParams } from '../../i18n/index.ts';

const REASON_KEYS: Readonly<Record<JevSkipReason, I18nKey>> = {
  tenant_aborted: 'guaranteed.jev.skip.tenant_aborted',
  media_lane: 'guaranteed.jev.skip.media_lane',
  rate_limit_or_timeout: 'guaranteed.jev.skip.rate_limit_or_timeout',
  status_not_judged: 'guaranteed.jev.skip.status_not_judged',
  client_fault: 'guaranteed.jev.skip.client_fault',
  queue_full: 'guaranteed.jev.skip.queue_full',
};

/**
 * 「近 1 小时 Jev 跳过：租户挂断 3、…」 for a SKU with Jev on (#2658: a Jev
 * with nothing to judge looked like one that never ran). Null when the
 * summary was not read (the line is left out rather than showing a
 * misleading zero).
 */
export function jevSkipLine(
  counts: JevSkipCounts | undefined,
  t: (key: I18nKey, params?: TParams) => string,
): string | null {
  if (counts === undefined) return null;
  const parts = JEV_SKIP_REASONS
    .filter((reason) => (counts[reason] ?? 0) > 0)
    .map((reason) => `${t(REASON_KEYS[reason])} ${String(counts[reason] ?? 0)}`);
  return parts.length === 0
    ? t('guaranteed.jev.skips_none')
    : t('guaranteed.jev.skips', { list: parts.join(t('guaranteed.jev.skips_sep')) });
}
